<template>
  <div class="home">
    <my-header-mobile/>
    <my-header/>
    <notice/>
    <protocol/>
    <census/>
    <info/>
    <new/>
    <honor/>
    <partner/>
    <my-footer/>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader'
import MyHeaderMobile from '@/components/MyHeaderMobile'
import Notice from '@/components/notice'
import Protocol from '@/components/Protocol'
import Census from '@/components/Census'
import Info from '@/components/Info'
import MyFooter from '@/components/Footer'
import New from "@/components/New"
import Honor from "@/components/Honor"
import Partner from "@/components/Partner";

export default {
  name: 'home',
  components: {
    Partner,
    Honor,
    New,
    MyHeader,
    MyHeaderMobile,
    Notice,
    Protocol,
    Census,
    Info,
    MyFooter
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style lang="less">
.home {
  background-color: white;
}
</style>
